import offStore from "@/pages/orderReport/offStore";
import shipRules from "@/pages/orderReport/shipRules";

import layout from "@/components/layout/layout";
const orderReport = {
  path: "/orderReport",
  component: layout,
  meta: {
    roles: ["shop", "r4gys"],
    title: "店铺管理",
    icon: "icon-jichushezhi"
  },
  children: [
    {
      path: "/orderReport/offStore",
      component: offStore,
      name: "offStore",
      meta: { roles: ["shop", "r4gys"], title: "店铺休店" }
    },
    {
      path: "/orderReport/shipRules",
      component: shipRules,
      name: "shipRules",
      meta: { roles: ["shop", "r4gys"], title: "发货规则" }
    }
  ]
};
export default orderReport;



// WEBPACK FOOTER //
// ./src/router/modules/orderReport.js